document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const navigation = document.querySelector('[data-nav]');

  if (menuButton && navigation) {
    const closeMenu = () => {
      navigation.classList.remove('is-open');
      menuButton.setAttribute('aria-expanded', 'false');
    };
    menuButton.addEventListener('click', () => {
      const isOpen = navigation.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && navigation.classList.contains('is-open')) {
        closeMenu();
        menuButton.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!navigation.contains(event.target) && !menuButton.contains(event.target)) closeMenu();
    });
    navigation.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });
    window.matchMedia('(min-width: 901px)').addEventListener('change', closeMenu);
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    updateProductState(section);
  });
});

document.addEventListener('click', async (event) => {
  const productQuantityButton = event.target.closest('[data-product-quantity]');
  if (productQuantityButton) {
    const productSection = productQuantityButton.closest('[data-product-section]');
    const input = productSection?.querySelector('[data-product-quantity-input]');
    if (!input) return;

    const current = Number.parseInt(input.value || '1', 10);
    const maximum = Number.parseInt(input.max || '999', 10);
    const next = productQuantityButton.dataset.productQuantity === 'increase'
      ? Math.min(maximum, current + 1)
      : Math.max(1, current - 1);
    input.value = String(next);
    return;
  }

  const quantityButton = event.target.closest('[data-quantity-action]');
  const removeButton = event.target.closest('[data-remove-item]');

  if (!quantityButton && !removeButton) return;

  const cartSection = event.target.closest('[data-cart-section]');
  const cartItem = event.target.closest('[data-cart-item]');
  if (!cartSection || !cartItem) return;

  event.preventDefault();
  const input = cartItem.querySelector('[data-quantity-input]');
  const currentQuantity = Number.parseInt(input?.value || '1', 10);
  const maximumQuantity = Number.parseInt(input?.max || '999', 10);
  let nextQuantity = 0;

  if (quantityButton) {
    nextQuantity = quantityButton.dataset.quantityAction === 'increase'
      ? Math.min(maximumQuantity, currentQuantity + 1)
      : Math.max(1, currentQuantity - 1);
  }

  await updateCartItem(cartSection, cartItem.dataset.lineKey, nextQuantity);
});

document.addEventListener('change', async (event) => {
  const collectionSort = event.target.closest('[data-collection-sort]');
  if (collectionSort) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', collectionSort.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
    return;
  }

  const variantSelect = event.target.closest('[data-variant-select]');
  if (variantSelect) {
    const productSection = variantSelect.closest('[data-product-section]');
    if (productSection) updateProductState(productSection);
    return;
  }

  const input = event.target.closest('[data-quantity-input]');
  if (!input) return;

  const cartSection = input.closest('[data-cart-section]');
  const cartItem = input.closest('[data-cart-item]');
  if (!cartSection || !cartItem) return;

  const quantity = Math.max(1, Number.parseInt(input.value || '1', 10));
  input.value = String(quantity);
  await updateCartItem(cartSection, cartItem.dataset.lineKey, quantity);
});

document.addEventListener('submit', async (event) => {
  const discountForm = event.target.closest('[data-discount-form]');
  if (!discountForm) return;

  event.preventDefault();
  const cartSection = discountForm.closest('[data-cart-section]');
  const input = discountForm.querySelector('[data-discount-input]');
  const submitButton = discountForm.querySelector('[data-discount-submit]');
  const error = discountForm.querySelector('[data-discount-error]');
  const code = input?.value.trim();

  if (!code || !cartSection) {
    if (error) error.hidden = false;
    input?.focus();
    return;
  }

  if (error) error.hidden = true;
  if (input) input.disabled = true;
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
  }

  const root = window.Shopify?.routes?.root || '/';

  try {
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ discount: code })
    });

    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || cart.message || 'Não foi possível aplicar o código.');

    const discountCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    const matchingCode = discountCodes.find((discount) => String(discount.code || '').toLowerCase() === code.toLowerCase());
    if (matchingCode && matchingCode.applicable === false) {
      throw new Error('Código não aplicável.');
    }

    const sectionResponse = await fetch(`${cartSection.dataset.cartUrl}?section_id=${cartSection.dataset.sectionId}`);
    if (!sectionResponse.ok) throw new Error('Não foi possível atualizar o carrinho.');

    const sectionHtml = await sectionResponse.text();
    const parser = new DOMParser();
    const nextDocument = parser.parseFromString(sectionHtml, 'text/html');
    const nextSection = nextDocument.querySelector('[data-cart-section]');
    if (!nextSection) throw new Error('Carrinho indisponível.');

    cartSection.replaceWith(nextSection);
    const nextStatus = nextSection.querySelector('[data-cart-status]');
    if (nextStatus) {
      nextStatus.textContent = 'Código aplicado ao carrinho.';
      nextStatus.focus({ preventScroll: true });
    }
  } catch (applyError) {
    if (error) error.hidden = false;
    if (input) {
      input.disabled = false;
      input.focus();
    }
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
    }
  }
});

function updateProductState(section) {
  const select = section.querySelector('[data-variant-select]');
  if (!select) return;

  const option = select.options[select.selectedIndex];
  const available = option.dataset.available === 'true';
  const inventoryLimited = Boolean(option.dataset.inventoryManagement) && option.dataset.inventoryPolicy === 'deny';
  const inventoryQuantity = Number.parseInt(option.dataset.inventoryQuantity || '0', 10);
  const price = section.querySelector('[data-product-price]');
  const quantity = section.querySelector('[data-product-quantity-input]');
  const quantityButtons = section.querySelectorAll('[data-product-quantity]');
  const addButton = section.querySelector('[data-add-to-cart]');
  const addLabel = section.querySelector('[data-add-to-cart-label]');
  const stockStatus = section.querySelector('[data-stock-status]');
  const stockLabel = section.querySelector('[data-stock-label]');
  const restock = section.querySelector('[data-back-in-stock]');
  const restockProduct = section.querySelector('[data-restock-product]');

  if (price) price.textContent = option.dataset.price;
  if (quantity) {
    quantity.disabled = !available;
    quantity.value = '1';
    if (inventoryLimited && inventoryQuantity > 0) {
      quantity.max = String(inventoryQuantity);
    } else {
      quantity.removeAttribute('max');
    }
  }

  quantityButtons.forEach((button) => {
    button.disabled = !available;
  });
  if (addButton) addButton.disabled = !available;
  if (addLabel) addLabel.textContent = available ? section.dataset.labelAdd : section.dataset.stockSoldOut;
  if (stockStatus) stockStatus.classList.toggle('stock-status--sold-out', !available);

  if (stockLabel) {
    if (!available) {
      stockLabel.textContent = section.dataset.stockSoldOut;
    } else if (inventoryLimited && inventoryQuantity === 1) {
      stockLabel.textContent = section.dataset.stockLastUnit;
    } else if (inventoryLimited && inventoryQuantity <= 5) {
      stockLabel.textContent = section.dataset.stockLow.replace('__COUNT__', String(inventoryQuantity));
    } else {
      stockLabel.textContent = section.dataset.stockInStock;
    }
  }

  restock?.classList.toggle('is-hidden', available);
  if (restockProduct) restockProduct.value = `${document.querySelector('.product-title')?.textContent || ''} — ${option.textContent.trim()}`;
  const variantUrl = new URL(window.location.href);
  variantUrl.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', variantUrl);
}

async function updateCartItem(cartSection, lineKey, quantity) {
  if (cartSection.classList.contains('is-updating')) return;
  const activeControl = document.activeElement;
  const focusAction = activeControl?.dataset.quantityAction;
  const wasQuantityInput = activeControl?.matches('[data-quantity-input]');
  const controls = cartSection.querySelectorAll('button, input, [data-remove-item]');
  const status = cartSection.querySelector('[data-cart-status]');

  controls.forEach((control) => {
    control.dataset.wasDisabled = String(Boolean(control.disabled));
    control.setAttribute('aria-disabled', 'true');
    if ('disabled' in control) control.disabled = true;
  });
  cartSection.classList.add('is-updating');

  try {
    const response = await fetch(cartSection.dataset.cartChangeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity })
    });

    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || cart.message);

    document.querySelectorAll('[data-cart-count]').forEach((counter) => {
      counter.textContent = cart.item_count;
    });

    const sectionResponse = await fetch(`${cartSection.dataset.cartUrl}?section_id=${cartSection.dataset.sectionId}`);
    if (!sectionResponse.ok) throw new Error('Section refresh failed');

    const sectionHtml = await sectionResponse.text();
    const parser = new DOMParser();
    const nextDocument = parser.parseFromString(sectionHtml, 'text/html');
    const nextSection = nextDocument.querySelector('[data-cart-section]');
    if (!nextSection) throw new Error('Cart section missing');

    cartSection.replaceWith(nextSection);
    const nextStatus = nextSection.querySelector('[data-cart-status]');
    if (nextStatus) nextStatus.textContent = quantity === 0 ? nextSection.dataset.cartRemoved : nextSection.dataset.cartUpdated;
    const nextItem = [...nextSection.querySelectorAll('[data-cart-item]')].find((item) => item.dataset.lineKey === lineKey);
    const nextControl = focusAction ? nextItem?.querySelector(`[data-quantity-action="${focusAction}"]`) : wasQuantityInput ? nextItem?.querySelector('[data-quantity-input]') : null;
    if (nextControl && !nextControl.disabled) nextControl.focus({ preventScroll: true });
    else nextStatus?.focus({ preventScroll: true });
  } catch (error) {
    cartSection.classList.remove('is-updating');
    controls.forEach((control) => {
      control.removeAttribute('aria-disabled');
      if ('disabled' in control) control.disabled = control.dataset.wasDisabled === 'true';
      delete control.dataset.wasDisabled;
    });
    if (status) {
      status.textContent = cartSection.dataset.cartError;
      status.focus({ preventScroll: true });
    }
  }
}

document.addEventListener('submit', async (event) => {
  const productForm = event.target.closest('form[action*="/cart/add"]');
  if (!productForm) return;

  event.preventDefault();
  await addProductWithoutLeavingPage(productForm);
});

async function addProductWithoutLeavingPage(productForm) {
  if (productForm.dataset.isAdding === 'true') return;

  const submitButton = productForm.querySelector('[type="submit"]');
  const label = submitButton?.querySelector('[data-add-to-cart-label]') || submitButton;
  const originalLabel = label?.textContent;
  const root = window.Shopify?.routes?.root || '/';

  productForm.dataset.isAdding = 'true';
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
  }
  if (label) label.textContent = 'A adicionar…';

  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(productForm)
    });
    const addedItem = await response.json();
    if (!response.ok) throw new Error(addedItem.description || addedItem.message || 'Não foi possível adicionar o artigo.');

    if (document.querySelector('[data-cart-section]')) {
      window.location.reload();
      return;
    }

    let cartItemCount;
    try {
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        cartItemCount = cart.item_count;
        document.querySelectorAll('[data-cart-count]').forEach((counter) => {
          counter.textContent = cart.item_count;
        });
      }
    } catch {}

    showCartNotice({
      title: 'Adicionado ao carrinho',
      productTitle: addedItem.product_title || addedItem.title,
      variantTitle: addedItem.variant_title,
      imageUrl: addedItem.featured_image?.url,
      cartUrl: `${root}cart`,
      message: cartItemCount >= 3
        ? 'Já pode usar o código PACK3 para receber 10%.'
        : cartItemCount === 2
          ? 'Falta 1 peça para poder usar o código PACK3.'
          : cartItemCount === 1
            ? 'Faltam 2 peças para poder usar o código PACK3.'
            : undefined
    });
    if (label) label.textContent = 'Adicionado ✓';
  } catch (error) {
    showCartNotice({
      title: 'Não foi possível adicionar',
      message: error.message || 'Tente novamente.',
      isError: true
    });
  } finally {
    window.setTimeout(() => {
      productForm.dataset.isAdding = 'false';
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
      if (label && originalLabel) label.textContent = originalLabel;
    }, 1200);
  }
}

function showCartNotice({ title, productTitle, variantTitle, imageUrl, cartUrl, message, isError = false }) {
  document.querySelector('[data-cart-notice]')?.remove();

  const returnFocus = document.activeElement;
  const notice = document.createElement('section');
  const dismissNotice = () => {
    const focusedInside = notice.contains(document.activeElement);
    notice.remove();
    if (focusedInside && returnFocus?.isConnected) returnFocus.focus();
  };
  notice.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') dismissNotice();
  });
  notice.className = `cart-notice${isError ? ' cart-notice--error' : ''}`;
  notice.dataset.cartNotice = '';
  notice.setAttribute('role', 'status');
  notice.setAttribute('aria-live', 'polite');

  const closeButton = document.createElement('button');
  closeButton.className = 'cart-notice__close';
  closeButton.type = 'button';
  closeButton.setAttribute('aria-label', 'Fechar');
  closeButton.textContent = '×';
  closeButton.addEventListener('click', dismissNotice);
  notice.append(closeButton);

  const content = document.createElement('div');
  content.className = 'cart-notice__content';

  if (imageUrl && !isError) {
    const image = document.createElement('img');
    image.className = 'cart-notice__image';
    image.src = imageUrl;
    image.alt = '';
    image.width = 88;
    image.height = 88;
    content.append(image);
  }

  const copy = document.createElement('div');
  const heading = document.createElement('strong');
  heading.className = 'cart-notice__title';
  heading.textContent = title;
  copy.append(heading);

  if (productTitle) {
    const product = document.createElement('span');
    product.className = 'cart-notice__product';
    product.textContent = variantTitle ? `${productTitle} — ${variantTitle}` : productTitle;
    copy.append(product);
  }
  if (message) {
    const detail = document.createElement('span');
    detail.className = 'cart-notice__product';
    detail.textContent = message;
    copy.append(detail);
  }
  content.append(copy);
  notice.append(content);

  if (!isError) {
    const actions = document.createElement('div');
    actions.className = 'cart-notice__actions';

    const continueButton = document.createElement('button');
    continueButton.className = 'cart-notice__continue';
    continueButton.type = 'button';
    continueButton.textContent = 'Continuar a comprar';
    continueButton.addEventListener('click', dismissNotice);

    const cartLink = document.createElement('a');
    cartLink.className = 'cart-notice__cart';
    cartLink.href = cartUrl;
    cartLink.textContent = 'Ver carrinho';
    actions.append(continueButton, cartLink);
    notice.append(actions);
  }

  document.body.append(notice);
}
